import { Injectable } from '@angular/core';

interface LogEntry {
  type: 'log' | 'info' | 'warn' | 'error' | 'uncaught';
  message: string;
  timestamp: string;
  trace?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConsoleLogger {
  private logs: string[] = [];

  private formatLogEntry(entry: LogEntry): string {
    return JSON.stringify(entry);
  }

  private formatArgument(arg: unknown): string {
    if (typeof arg === 'object') {
      return JSON.stringify(arg);
    }
    return String(arg);
  }

  interceptConsole(): void {
    const originalConsole = { ...console };
    type ConsoleMethod = 'log' | 'info' | 'warn' | 'error';

    const methods: ConsoleMethod[] = ['log', 'info', 'warn', 'error'];

    methods.forEach((method) => {
      console[method] = (...args: unknown[]) => {
        const entry: LogEntry = {
          type: method,
          message: args
            .map((arg) =>
              typeof arg === 'object' ? JSON.stringify(arg) : String(arg),
            )
            .join(' '),
          timestamp: new Date().toISOString(),
          trace: new Error().stack,
        };
        this.logs.push(this.formatLogEntry(entry));
        originalConsole[method](...args);
      };
    });
  }

  getLogs(): string[] {
    this.logs = [];
    this.interceptConsole();
    return this.logs;
  }
}
